export enum AwagerEvents {
  GAME_READY = 'gameReady',
  ROUND_START = 'gameRoundStart',
  ROUND_END = 'gameRoundEnd',
  UPDATE_BALANCE = 'updateBalance',
  SOUND_ON = 'enableAudio',
  SOUND_OFF = 'disableAudio',
  SHOW_QUICK_DEPOSIT = 'showQuickDeposit',
  GAME_FINISHED = 'gameFinished',
  BACK_TO_PARTNER = 'backToPartner',
  MACHINE_LOAD_ENDED = 'gameLoadingEnded',
  CRITICAL_ERROR = 'criticalError',
  OUT_OF_FUNDS = 'outOfFunds',
  LIMIT_REACHED = 'limitReached',
  SESSION_EXPIRED = 'sessionExpired',
  PAYTABLE = 'payTable',
  HOW_TO_PLAY = 'howToPlay',
  GAME_SWITCH = 'gameSwitch',
}

export type AwagerEventData = {
  source: 'awager' | 'FD';
  type: AwagerEventDataSound | AwagerEventUpdateBalance | AwagerEfEvents;
  timestamp?: number;
};

type AwagerEfEvents = 'howToPlay' | 'payTable';
type AwagerEventDataSound = 'enableAudio' | 'disableAudio';
type AwagerEventUpdateBalance = 'updateBalance';
